import React from 'react';
import { Grid, Table } from 'antd';

const { useBreakpoint } = Grid;

/**
 * Ant Design table with the shared look, plus a phone layout.
 *
 * When `mobileCard` is given, screens below `md` render the same rows as a
 * stacked card list instead of a wide table. It is still an Ant table under the
 * hood — only the columns are swapped — so pagination, loading and `onChange`
 * keep working exactly as on desktop.
 */
export default function DataTable({
    columns,
    mobileCard,
    rowKey = 'id',
    scrollX = 960,
    className = '',
    ...rest
}) {
    const screens = useBreakpoint();
    const asCards = Boolean(mobileCard) && screens.md === false;

    const cardColumns = React.useMemo(
        () => [{ key: '__card', render: (_, record, index) => mobileCard(record, index) }],
        [mobileCard]
    );

    return (
        <Table
            {...rest}
            rowKey={rowKey}
            columns={asCards ? cardColumns : columns}
            showHeader={!asCards}
            scroll={asCards ? undefined : { x: scrollX }}
            className={`patients-table ${asCards ? 'data-table--cards' : ''} ${className}`}
            size="small"
            rowHoverable={!asCards}
        />
    );
}
